define('presentation/developer/viewModels/deactivateNumbersViewModel',[
    'common/collections/collectionFilter',
    'common/collections/collectionSorter',
    'common/promises/promiseFactory',
    'presentation/common/modal',
    'presentation/developer/facades/deactivateNumbersFacade',
    'presentation/developer/validators/numberManagementValidator',
    'presentation/developer/viewModels/deactivateNumbersModalViewModel',
], function() {
    return function() {
        let self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const FilterConstructor = require('common/collections/collectionFilter');
        const DeactivateNumbersModalViewModelConstructor = require('presentation/developer/viewModels/deactivateNumbersModalViewModel');

        let _facade = null;
        let _modalService = null;
        let _sorter = null;
        let _validator = null;

        const _sortAsc = ko.observable(true);
        const _sortBy = ko.observable("phoneNumber");

        const MAX_NUMBERS_TO_DEACTIVATE = 100;

        const _countOfSelectedPhoneNumbers = () => _availablePhoneNumbers().reduce(
            (sum, v) => v.isSelected() ?
                sum + 1 :
                sum,
            0
        );

        const _selectAllPhoneNumbers = (selectAll) => {
            if (selectAll) {
                let countOfSelectedPhoneNumbers = _countOfSelectedPhoneNumbers();
                let i = 0;
                const availablePhoneNumbers = _availablePhoneNumbers();
                while (i < availablePhoneNumbers.length && countOfSelectedPhoneNumbers < MAX_NUMBERS_TO_DEACTIVATE) {
                    if (availablePhoneNumbers[i].isSelected() === false) {
                        availablePhoneNumbers[i].isSelected(true);
                        countOfSelectedPhoneNumbers++;
                    }
                    i++;
                }
            } else {
                _availablePhoneNumbers.forEach(phoneNumber => phoneNumber.isSelected(false));
            }
        };

        const _availablePhoneNumbers = ko.observableArray([]);

        const _filteredPhoneNumbers = ko.pureComputed(() => {
            let filteredPhoneNumbers;
            const filterContent = self.phoneNumbersFilter().trim().toLowerCase();
            if (filterContent) {
                let phoneNumbersFilter = new FilterConstructor();
                filteredPhoneNumbers = phoneNumbersFilter.addProperties(['phoneNumber','phoneNumberName','addedDateTime'])
                    .addValue(filterContent)
                    .filter(_availablePhoneNumbers());
            } else {
                filteredPhoneNumbers = _availablePhoneNumbers();
            }

            return filteredPhoneNumbers;
        });

        const displayedPhoneNumbers = ko.pureComputed(() => {
            const displayedPhoneNumbers = _filteredPhoneNumbers();
            _sorter.multiSort(displayedPhoneNumbers, [_sortBy()], [_sortAsc()]);
            return displayedPhoneNumbers;
        });

        self.dataGridConfig = {};

        self.accountNumber = ko.observable('');
        self.phoneNumbersFilter = ko.observable('');
        self.selectedAll = ko.observable(false);
        self.selectedAll.subscribe(_selectAllPhoneNumbers);
        self.showDataGrid = ko.pureComputed(() => _availablePhoneNumbers().length > 0);
        self.showMaxDeactivate = ko.pureComputed(() => _availablePhoneNumbers().length > MAX_NUMBERS_TO_DEACTIVATE);
        self.selectAllText = ko.pureComputed(() => self.showMaxDeactivate() ?
            `Select First ${MAX_NUMBERS_TO_DEACTIVATE} Numbers` :
            'Select All Numbers'
        );

        const _refreshDisplayedPhoneNumbers = () => {
            return _promiseFactory.deferIndefinitely(function(deferredObject) {
                _facade.getAllActivePhoneNumbers(self.accountNumber())
                    .fail(deferredObject.reject)
                    .done((phoneNumbers) => {
                        _availablePhoneNumbers(phoneNumbers);
                        self.selectedAll(false);
                        deferredObject.resolve();
                    });
            });
        };

        const _selectRow = (row) => {
            let selectedNumber = _availablePhoneNumbers().find(p => p.phoneNumber === row.phoneNumber);
            selectedNumber.isSelected(!selectedNumber.isSelected());

            if (_countOfSelectedPhoneNumbers() > MAX_NUMBERS_TO_DEACTIVATE) {
                selectedNumber.isSelected(false);
            }
        };

        const _sortColumn = (column, sortAsc) => {
            const sortBy = column === "addedDateTime" ? "createdDateTime.sortValue" : column;
            if (_sortBy() !== sortBy) {
                _sortBy(sortBy);
            }
            if (sortAsc !== _sortAsc()) {
                _sortAsc(sortAsc);
            }
        };

        self.launchDeactivatePhoneNumbersModal = () => {
            let onModalSavePromise = _promiseFactory.deferIndefinitely();
            let selectedPhoneNumbers = displayedPhoneNumbers().filter(p => p.isSelected());
            let modal = new DeactivateNumbersModalViewModelConstructor(onModalSavePromise);
            modal.fromAccountNumber(self.accountNumber());
            modal.selectedNumbers(selectedPhoneNumbers);

            _modalService.showModal(modal);
            onModalSavePromise
                .done((result) => {
                    if (result.action === "submit") {
                        _refreshDisplayedPhoneNumbers();
                    }
                })
                .fail((error) => {
                    throw error;
                });
        };

        self.refreshResults = () => {
            return _promiseFactory.deferIndefinitely(function (deferredObject) {
                _validator.validate()
                    .fail(deferredObject.reject)
                    .done((isValid) => {
                        if(isValid === false) {
                            deferredObject.resolve();
                            return;
                        }
                        _refreshDisplayedPhoneNumbers()
                            .fail(deferredObject.reject)
                            .done(deferredObject.resolve);
                    });
            });
        };

        self.activate = () => {
            const Facade = require('presentation/developer/facades/deactivateNumbersFacade');
            _facade = new Facade();
            _facade.init();

            const ModalConstructor = require('presentation/common/modal');
            _modalService = new ModalConstructor();

            const SorterConstructor = require('common/collections/collectionSorter');
            _sorter = new SorterConstructor();

            const ValidatorConstructor = require('presentation/developer/validators/numberManagementValidator');
            _validator = new ValidatorConstructor();

            return _initialize();
        };

        const _initialize = () => {

            self.dataGridConfig.dataSet = displayedPhoneNumbers;
            self.dataGridConfig.selectRowCallback = _selectRow;
            self.dataGridConfig.sortColumnCallback = _sortColumn;
            self.dataGridConfig.hasRowDetails = false;
            self.dataGridConfig.columns = [
                {"header": "Selected", "key": "isSelected", "isSortable": true, "isSelectable": true},
                {"header": "Phone Number Name", "key": "phoneNumberName", "isSortable": true},
                {"header": "Phone Number", "key": "phoneNumber", "isSortable": true, "sortAsc": true},
                {"header": "Added", "key": "addedDateTime", "isSortable": true},
            ];

            _validator.registerViewModel(self, _facade);

            return _promiseFactory.wait();
        };
    };
});

